"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevealButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const icon_button_styles_1 = require("@/components/common/icon-button/icon-button.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/common/icon");
/**
 * 비밀번호 등 가려진 입력값의 노출 여부를 토글하는 버튼.
 * revealed 상태에 따라 eye / eye-closed 아이콘으로 전환됩니다.
 */
let RevealButton = class RevealButton extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.revealed = false;
        this.disabled = false;
    }
    render() {
        return (0, lit_1.html) `
      <button
        type="button"
        aria-pressed=${this.revealed ? 'true' : 'false'}
        aria-label=${this.revealed ? '비밀번호 숨기기' : '비밀번호 보기'}
        ?disabled=${this.disabled}
        @click=${this.handleClick}
      >
        <mm-icon name=${this.revealed ? icon_names_1.ICON_NAMES.HIDE : icon_names_1.ICON_NAMES.VIEW}></mm-icon>
      </button>
    `;
    }
    handleClick() {
        if (this.disabled)
            return;
        this.revealed = !this.revealed;
        (0, utils_1.emit)(this, 'toggle', { revealed: this.revealed }, { bubbles: false, composed: false });
    }
};
RevealButton.styles = [shared_styles_1.resetStyles, icon_button_styles_1.iconButtonStyles];
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], RevealButton.prototype, "revealed", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], RevealButton.prototype, "disabled", void 0);
RevealButton = __decorate([
    (0, decorators_js_1.customElement)('mm-reveal-button')
], RevealButton);
exports.RevealButton = RevealButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmV2ZWFsLWJ1dHRvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJldmVhbC1idXR0b24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQXNDO0FBQ3RDLHFEQUEyRDtBQUUzRCxvRUFBZ0U7QUFDaEUsMkZBQXFGO0FBQ3JGLCtEQUF5RDtBQUN6RCxtQ0FBOEI7QUFDOUIsb0NBQWlDO0FBRWpDOzs7R0FHRztBQUVJLElBQU0sWUFBWSxHQUFsQixNQUFNLFlBQWEsU0FBUSxnQkFBVTtJQUFyQzs7UUFFd0IsYUFBUSxHQUFHLEtBQUssQ0FBQTtRQUNoQixhQUFRLEdBQUcsS0FBSyxDQUFBO0lBcUIvQyxDQUFDO0lBbkJDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7dUJBR1EsSUFBSSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxPQUFPO3FCQUNsQyxJQUFJLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDLFNBQVM7b0JBQ3ZDLElBQUksQ0FBQyxRQUFRO2lCQUNoQixJQUFJLENBQUMsV0FBVzs7d0JBRVQsSUFBSSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsdUJBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLHVCQUFVLENBQUMsSUFBSTs7S0FFcEUsQ0FBQTtJQUNILENBQUM7SUFFTyxXQUFXO1FBQ2pCLElBQUksSUFBSSxDQUFDLFFBQVE7WUFBRSxPQUFNO1FBQ3pCLElBQUksQ0FBQyxRQUFRLEdBQUcsQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFBO1FBQzlCLElBQUEsWUFBSSxFQUFDLElBQUksRUFBRSxRQUFRLEVBQUUsRUFBRSxRQUFRLEVBQUUsSUFBSSxDQUFDLFFBQVEsRUFBRSxFQUFFLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxRQUFRLEVBQUUsS0FBSyxFQUFFLENBQUMsQ0FBQTtJQUN4RixDQUFDOztBQXRCTSxtQkFBTSxHQUFHLENBQUMsMkJBQVcsRUFBRSxxQ0FBZ0IsQ0FBQyxDQUFBO0FBQ2xCO0lBQTVCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsQ0FBQzs4Q0FBaUI7QUFDaEI7SUFBNUIsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxDQUFDOzhDQUFpQjtBQUhsQyxZQUFZO0lBRHhCLElBQUEsNkJBQWEsRUFBQyxrQkFBa0IsQ0FBQztHQUNyQixZQUFZLENBd0J4QjtBQXhCWSxvQ0FBWSJ9